import { IAddress } from '@pepperhq/types-sdk';
import { HttpClient } from 'components/http/HttpClient';
import { UserAddress } from 'components/user/model/User';

interface AddressResource {
    line1: string;
    line2?: string;
    city: string;
    region?: string;
    postalCode: string;
    country: string;
}

export interface SuggestionResponseItem extends AddressResource {
    title: string;
}

export class AddressApi extends HttpClient {
    constructor() {
        super({
            baseURL: process.env.API_SERVER_URL,
            url: '/addresses'
        });
    }

    public async geocode(data: AddressResource) {
        return this.postRequest<AddressResource, { position: [number, number] }>({
            url: '/addresses/geocode',
            data
        });
    }
    public async createUserAddress(userId: string, data: IAddress) {
        return this.postRequest<IAddress, UserAddress[]>({
            url: `/users/${userId}/addresses`,
            data
        });
    }
    // [Longtitude, Latitude]
    public async reverseGeocode(position: [number, number]) {
        return this.postRequest<{ position: [number, number] }, { items: SuggestionResponseItem[] }>({
            url: '/addresses/suggest',
            data: { position }
        });
    }
    public async delete(userId: string, addressId: string) {
        return this.deleteRequest<UserAddress[]>({
            url: `/users/${userId}/addresses/${addressId}`
        });
    }
}

export const addressApi = new AddressApi();
